<template>
  <v-navigation-drawer width="320" v-model="drawer" fixed right temporary dark>
    <!-- <data-tracker class="ml-n24">
      <p>
        <span class="text-body-1">Preferred language:</span>
        {{ this.$store.getters["Profile/preferredLanguage"] }}
      </p>
    </data-tracker> -->
    
    <v-sheet color="surfaceDark darken-2" v-if="!submenu">
      <v-list>
        <v-list-item class="py-3 nav-heading">
          <v-list-item-title class="caption">{{ time }}</v-list-item-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="drawer = false" class="mr-n3">
            <v-icon>{{ icons['close'] }}</v-icon>
          </v-btn>
        </v-list-item>
        <v-divider class="mt-16"></v-divider>

        <v-list-item two-line dense>
          <v-icon color="grey lighten-1" class="mr-2" large @click="refreshAPI()">
            {{ icons['user'] }}
          </v-icon>
          <v-list-item-content>
            <v-list-item-title>{{ accountInfo.userName.value }}</v-list-item-title>
            <v-list-item-subtitle>{{ balanceInfo.currency.label }} {{ balanceInfo.balance.amount }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item class="dense-list" dense>
          <v-list-item-title class="text-caption">{{ balanceInfo.eligibleWithdrawal.label }}</v-list-item-title>
          <v-spacer></v-spacer>
          <v-list-item-subtitle class="text-right">{{ balanceInfo.currency.label }} {{ balanceInfo.eligibleWithdrawal.value }}</v-list-item-subtitle>
        </v-list-item>

        <v-list-item class="dense-list pb-4" dense>
          <v-list-item-title class="text-caption">{{ balanceInfo.remainingRollover.label }}</v-list-item-title>
          <v-spacer></v-spacer>
          <v-list-item-subtitle class="text-right">{{ balanceInfo.currency.label }} {{ balanceInfo.remainingRollover.value }}</v-list-item-subtitle>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item class="my-2">
          <v-list-item-title class="primary--text text--darken-1 text-h6">
            <span class="">Let's play</span>
          </v-list-item-title>
        </v-list-item>

        <v-list-item class="pb-0">
          <v-row dense id="products-tile" class="mb-2">
            <v-col v-for="(nav, i) in fullNavLabels" :key="i" cols="4" dark>
              <v-btn @click=";(drawer = false), changeRoute(nav.path)" block elevation="0" color="primary">
                <v-icon color="secondary" size="32">
                  {{ icons[nav.icon] }}
                </v-icon>
                <v-spacer></v-spacer>
                <div class="caption white--text">{{ nav.label }}</div>
              </v-btn>
            </v-col>
          </v-row>
        </v-list-item>
      </v-list>
    </v-sheet>

    <v-list v-if="!submenu" class="nav-menu">
      <div v-for="(item, i) in menuItems" :key="i + item.label">
        <v-list-item @click="clickMenuItem(item)" link :disabled="!item.enabled">
          <v-list-item-title>{{ item.label === 'Language' ? languageSetting.label : item.label }}</v-list-item-title>
          <v-list-item-action>
            <v-icon v-if="item.type === 'parent'" :disabled="item.enabled">{{ icons['chevronRight'] }}</v-icon>
            <v-icon v-else-if="item.label === 'Language'" :disabled="item.enabled">${{ languageSetting.icon }}</v-icon>
            <v-icon v-else-if="item.type === 'icon'" :disabled="item.enabled">{{ icons[item.icon] }}</v-icon>
            <v-badge inline v-else-if="item.type === 'badge'" :content="item.badgeCount" color="red"></v-badge>
            <v-icon v-else color="transparent">{{ icons['chevronRight'] }}</v-icon> <!-- Pseudo element to keep the list item's height consistent -->
          </v-list-item-action>
        </v-list-item>
        <v-divider light v-if="i < menuItems.length - 1"></v-divider>
      </div>
    </v-list>

    <v-slide-x-reverse-transition>
      <v-list v-if="submenu">
        <v-list-item class="py-3 px-4 nav-heading">
          <v-btn icon @click="submenu = false">
            <v-icon>{{ icons['arrowLeft'] }}</v-icon>
          </v-btn>
          <v-list-item-title class="font-weight-bold ml-4">{{ parent }}</v-list-item-title>
        </v-list-item>

        <v-divider class="mt-16"></v-divider>
        <div v-for="(item, i) in subMenuItems" :key="i">
          <v-list-item link v-if="item.parent === parent" @click="item.path ? changeRoute(item.path) : updatePreferredLanguage(item.label), (drawer = false)">
            <v-list-item-title class="text-body-2">{{ item.label }}</v-list-item-title>
            <v-list-item-action>
            <v-icon>${{ item.icon }}</v-icon>
          </v-list-item-action>
          </v-list-item>
          <v-divider light v-if="i < subMenuItems.length && item.parent === parent"></v-divider>
        </div>
      </v-list>
    </v-slide-x-reverse-transition>
  </v-navigation-drawer>
</template>

<script>
import moment from "moment"
export default {
  data() {
    return {
      drawer: false,
      submenu: false,
      parent: '',
      time: ''
    }
  },
  watch: {
    drawerIsOn() {
      this.drawer = this.drawerIsOn
    },
    drawer() {
      this.$store.dispatch('Drawer/toggleDrawer', this.drawer)
      !this.drawer && (this.submenu = false)
    },
  },
  computed: {
    drawerIsOn() {
      return this.$store.getters['Drawer/isOn']
    },
    menuItems() {
      return this.$store.getters['Drawer/menuItems']
    },
    subMenuItems() {
      return this.$store.getters['Drawer/subMenuItems']
    },
    balanceInfo() {
      return this.$store.getters['Profile/balanceInfo']
    },
    accountInfo() {
      return this.$store.getters['Profile/accountInfo']
    },
    locationInfo(){
      return this.$store.getters['Profile/locationInfo']
    },
    preferredLanguage(){
      return this.$store.getters['Profile/preferredLanguage']
    },
    languageSetting() {
      let item = { label: '', icon: ''}
      switch (this.preferredLanguage) {
        case 'zh':
          item.label = '简体'
          item.icon = 'cn'
          break
        default:
          item.label = 'English'
          item.icon = 'uk'
      }
      return item
    }
  },
  methods: {
    openSubmenu(parent) {
      this.submenu = true
      this.parent = parent
    },
    clickMenuItem(item){
      item.type === 'parent' || item.type === 'icon' 
      ? this.openSubmenu(item.label)
      : this.changeRoute(item.path)
    },
    updatePreferredLanguage(label){
      this.$store.dispatch('Profile/updatePreferredLanguage', label)
    },
    timeInterval(){
      setInterval(()=>{
        this.time = `${moment().format('h:mm:ss')} (GMT ${this.locationInfo.timeZone.info.gmt})`
      } ,1000)
    }
  },
  mounted() {
    this.drawer = this.drawerIsOn
    this.timeInterval()
  },
}
</script>

<style lang="sass" scoped>
.dense-list
  min-height: 1.5rem !important

.nav-heading
  background-color: #080808
  position: fixed
  top: 0
  width: 100%
  z-index: 2

#products-tile
  .v-btn
    // For product tile layout
    flex-direction: column
    align-items: stretch
    white-space: normal

    border-radius: 16px
    height: 84px
    padding: 8px
    text-align: left
    text-transform: none

    ::v-deep .v-btn__content
      // For product tile layout
      flex-direction: column
      align-items: flex-start

.nav-menu
  ::v-deep .theme--light.v-divider
    border-color: rgba(0, 0, 0, 0.08) // Override nav-drawer's dark theme divider
</style>
